// SPDX-License-Identifier: AGPL-3.0-or-later

import sectionStyles from '@app/features/app/components/dialogs/shared/SettingsSection.module.css';
import styles from '@app/features/app/components/dialogs/shared/SettingsTabLayout.module.css';
import {clsx} from 'clsx';
import type React from 'react';

interface SettingsTabContainerProps {
	children: React.ReactNode;
	className?: string;
}
export const SettingsTabContainer: React.FC<SettingsTabContainerProps> = ({children, className}) => {
	return <div className={clsx(styles.container, className)}>{children}</div>;
};
interface SettingsTabHeaderProps {
	title: React.ReactNode;
	description?: React.ReactNode;
	className?: string;
}
export const SettingsTabHeader: React.FC<SettingsTabHeaderProps> = ({title, description, className}) => {
	return (
		<div className={clsx(styles.header, className)}>
			<h2 className={styles.title}>{title}</h2>
			{description && <p className={styles.description}>{description}</p>}
		</div>
	);
};
interface SettingsTabContentProps {
	children: React.ReactNode;
	className?: string;
}
export const SettingsTabContent: React.FC<SettingsTabContentProps> = ({children, className}) => {
	return <div className={clsx(styles.content, className)}>{children}</div>;
};
interface SettingsTabSectionProps {
	title?: React.ReactNode;
	description?: React.ReactNode;
	children: React.ReactNode;
	className?: string;
}
export const SettingsTabSection: React.FC<SettingsTabSectionProps> = ({title, description, children, className}) => {
	return (
		<div className={clsx(styles.subsection, className)}>
			{(title || description) && (
				<div className={sectionStyles.subsectionHeader}>
					{title && <h4 className={sectionStyles.subsectionTitle}>{title}</h4>}
					{description && <p className={sectionStyles.subsectionDescription}>{description}</p>}
				</div>
			)}
			<div className={sectionStyles.subsectionContent}>{children}</div>
		</div>
	);
};
